<fieldset class="grid" data-test-id="aufgabe-messbrief">
	<fieldset aria-label="Einstellungen zum Messbrief">
		<div class="row">
			@if (isMessbrief()) {
				<mat-checkbox
					color="primary"
					class="focus-inwards-dark"
					[formControl]="bodyControls.mitUsigVersehen"
					data-test-id="aufgabe-messbrief-checkbox-usig">
					Messbrief mit U-Signal versehen
				</mat-checkbox>
			}
		</div>
		<div class="row">
			<mat-checkbox
				color="primary"
				class="focus-inwards-dark"
				[formControl]="bodyControls.mitVermerkVersehen"
				data-test-id="aufgabe-messbrief-checkbox-vermerk">
				{{ urkundenName() }} mit Eintragungsvermerk versehen
			</mat-checkbox>
		</div>
		<div class="row">
			<mat-checkbox
				color="primary"
				class="focus-inwards-dark"
				[formControl]="bodyControls.original"
				(change)="toggleOriginalAnGroup($event.checked)"
				data-test-id="aufgabe-messbrief-checkbox-original">
				Original senden/Aushändigen an
			</mat-checkbox>
		</div>
		@if (bodyControls.originalAn.enabled) {
			<fieldset class="row" aria-label="Empfänger wählen" data-test-id="original-an">
				<div class="column-sub" data-test-id="empfaenger-original">
					<mat-checkbox
						color="primary"
						class="focus-inwards-dark"
						[formControl]="originalAnControls.eigentuemer"
						data-test-id="aufgabe-messbrief-original-checkbox-eigentuemer">
						Eigentümer
					</mat-checkbox>
					<mat-checkbox
						color="primary"
						class="focus-inwards-dark"
						[formControl]="originalAnControls.vertreter"
						data-test-id="aufgabe-messbrief-original-checkbox-vertreter">
						Vertreter
					</mat-checkbox>
				</div>
			</fieldset>
		}
		<div class="row">
			<mat-checkbox
				color="primary"
				class="focus-inwards-dark"
				[formControl]="bodyControls.vorabKopie"
				data-test-id="aufgabe-messbrief-checkbox-vorabkopie">
				vorab begl. Kopie
			</mat-checkbox>
		</div>
		<div class="row">
			<mat-checkbox
				color="primary"
				class="focus-inwards-dark"
				[formControl]="bodyControls.zda"
				data-test-id="aufgabe-messbrief-checkbox-zda">
				Kopie z. d. A.
			</mat-checkbox>
		</div>
		<div class="row">
			<mat-checkbox
				color="primary"
				class="focus-inwards-dark"
				[formControl]="bodyControls.ergaenzen"
				(change)="toggleErgaenzenSendenGroup($event.checked)"
				data-test-id="aufgabe-messbrief-checkbox-ergaenzen">
				{{ urkundenName() }} ergänzen
			</mat-checkbox>
		</div>
		@if (bodyControls.ergaenzenSenden.enabled) {
			<div class="row, additionalline">
				(bei Löschung: {{ isMessbrief() ? 'U-Signal röten bzw.' : '' }} Eintragungsvermerk röten) + senden an
			</div>
			<fieldset class="row" aria-label="Empfänger wählen">
				<div class="column-sub" data-test-id="empfaenger-ergaenzen">
					@if (isBSR()) {
						<mat-checkbox
							color="primary"
							class="focus-inwards-dark"
							[formControl]="ergaenzenSendenControls.gdwsMainz"
							data-test-id="aufgabe-messbrief-ergaenzen-checkbox-gdws-mainz">
							GDWS Mainz
						</mat-checkbox>
					} @else {
						<mat-checkbox
							color="primary"
							class="focus-inwards-dark"
							[formControl]="ergaenzenSendenControls.bsh"
							data-test-id="aufgabe-messbrief-ergaenzen-checkbox-bsh">
							BSH
						</mat-checkbox>
					}
					<mat-checkbox
						color="primary"
						class="focus-inwards-dark"
						[formControl]="ergaenzenSendenControls.einreicher"
						data-test-id="aufgabe-messbrief-original-checkbox-einreicher">
						Einreicher
					</mat-checkbox>
				</div>
			</fieldset>
		}
	</fieldset>
	<schir-int-client-notiz-in-aufgabe-editor class="row note" [aufgabenTyp]="aufgabenTyp()" />
</fieldset>
